import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';
import {TablesTranslations} from '~shared/components/tables/tables-translations.service';
import {SidebarService} from '~core/components/sidebar/sidebar.service';
import {ClubService, NavigationService, ReminderService, ScreenSizeService, StorageService} from '~core/services';
import {BasicStatusTranslationService, TooltipTranslationService} from '~shared/translations';
import {HomeRemindersComponent} from '../components/home-reminders.component';

/**
 * Open-only home reminders
 */
@UntilDestroy()
@Component({
  templateUrl: '../components/home-reminders.component.html'
})
export class OpenHomeRemindersComponent extends HomeRemindersComponent implements OnInit, OnDestroy {
  constructor(
    public clubService: ClubService,
    public reminderService: ReminderService,
    public basicStatusTranslationService: BasicStatusTranslationService,
    public route: ActivatedRoute,
    public storage: StorageService,
    public tablesTranslations: TablesTranslations,
    public sidebarService: SidebarService,
    public navigationService: NavigationService,
    public tooltipTranslations: TooltipTranslationService,
    public router: Router,
    public screenSizeService: ScreenSizeService,
  ) {
    super(clubService, reminderService, basicStatusTranslationService, route, storage,
      tablesTranslations, sidebarService, navigationService, tooltipTranslations, router, screenSizeService);
    this.navigationService.setCurrentPage('homeOpenReminders');
    this.navigationService.setCurrentBreadcrumbs(['crm', 'homeOpenReminders']);
    this.i18nHeading = $localize`:@@clubComponent.heading.openReminders:Open Reminders`;
  }

  public ngOnDestroy(): void {
  }

  /**
   * Initialization method
   */
  public ngOnInit(): any {
    this.setUp();
    this.getLatestReminders(this.authenticatedUser.id);
  }

  /**
   * Get the reminders for the current customer.
   */
  public getLatestReminders(id: number): any {
    const endpoint = this.reminderService.getStatusUserRemindersEndpoint(id, 'open');
    this.baseApi = endpoint[0];
    this.customQueries = endpoint[1];
    this.loading = false;
  }

}
